import "./styles/Main.scss";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "@components/ScrollToTop";
import AppRoutes from "@components/Routes";
import { SnackbarProvider } from "notistack";
import { LanguageCurrencyProvider } from "@context/LanguageCurrencyContext";
import { TokenProvider } from "@context/TokenContext";
import { CartProvider } from "@context/CardContext";

function App() {

  return (
    <Router>
      <ScrollToTop />

      <TokenProvider>

        <SnackbarProvider maxSnack={1} autoHideDuration={2000}>

          <CartProvider>

            <LanguageCurrencyProvider>

              <AppRoutes />

            </LanguageCurrencyProvider>

          </CartProvider>
          
        </SnackbarProvider>

      </TokenProvider>

    </Router >
  );


}

export default App;
